import React from 'react';
import { useIntl } from 'react-intl';
import { PiArrowsOutSimple } from 'react-icons/pi';
import { TOOLTIP_PLACEMENT_LEFT } from '@aibuild/ui';
import ChromeButton from './ChromeButton';
import { ExpandSlot } from './ExpandButton.styled';
import { messages } from './messages';

export interface ExpandButtonProps {
  onExpand: () => void;
  /** The viewer's only control, in one too small for its tools: below the cube, on a surface of its own. */
  standalone?: boolean;
}

const ExpandButton: React.FC<ExpandButtonProps> = ({ onExpand, standalone = false }) => {
  const intl = useIntl();
  return (
    <ExpandSlot $standalone={standalone}>
      <ChromeButton
        label={intl.formatMessage(messages.expand)}
        icon={<PiArrowsOutSimple />}
        tooltipPlacement={TOOLTIP_PLACEMENT_LEFT}
        onClick={onExpand}
        testId="model-viewer__expand"
      />
    </ExpandSlot>
  );
};

export default ExpandButton;
